module.exports = __webpack_public_path__ + "img/15.c26798a9.png";